import axios, {AxiosResponse} from 'axios';
import type {IVoiceApiMethods} from '@wholesalechange/videocomponent';
import {ISpeechRecognitionResponse} from '../dialogue/interfaces';
import {toAvatarApiError} from './avatarSession';

// Voice, language and rate are resolved from the bot on the server; the Azure key never reaches the browser.
export const synthesizeSpeechApi = (botId: number, text: string): Promise<AxiosResponse<Blob>> => {
  return axios.post(
    `${process.env.REACT_APP_API_URL}/speech/synthesize`,
    {
      botId,
      text
    },
    {
      responseType: 'blob'
    }
  );
};

export const recognizeSpeechApi = (botId: number, audio: Blob): Promise<AxiosResponse<ISpeechRecognitionResponse>> => {
  return axios.post(
    `${process.env.REACT_APP_API_URL}/speech/recognize`,
    audio,
    {
      params: {botId},
      headers: {'Content-Type': 'audio/wav'}
    }
  );
};

// Adapts the API calls to the videocomponent contract: resolve with the bare value, reject with IAvatarApiError.
export const voiceApiMethods: IVoiceApiMethods = {
  synthesize: async (botId, text) => {
    try {
      const {data} = await synthesizeSpeechApi(botId, text);

      return data;
    } catch (error) {
      throw toAvatarApiError(error);
    }
  },
  recognize: async (botId, audio) => {
    try {
      const {data} = await recognizeSpeechApi(botId, audio);

      return data.text || '';
    } catch (error) {
      throw toAvatarApiError(error);
    }
  }
};
